import type { Resource } from '../../';
export const country_countries_KR: Resource = {"default":"South Korea"};
